function Rules(): JSX.Element {
  return (
    <div className="rules-container text-center">
      <h2 className=" h2 margin-bottom-2">Guidelines </h2>
      <ul className="rules-list">
        <li>There are 10 questions in total.</li>
        <li>You can answer any number of questions.</li>
        <li>The questions are of multiple choice.</li>
        <li>Each question carries 5 marks.</li>
        <li>Once an answer is chosen, you will not be able to change it.</li>
      </ul>
      <h3 className="h3">Good luck!</h3>
    </div>
  );
}

export { Rules };
